import React from 'react';
import { ISourceDefinition } from '@stores/sourceDefinitionsList';
import Loading from '@ui-library/Loading';
import JSONSchemaForm, { JSONSchema } from '@components/common/jsonSchemaForm/jsonSchemaForm';
import { SecretConfig } from '@stores/source';
import { SourceNameInputContainer as Container } from '../styles';
import classes from './style.module.scss';
import { useConfigSchema } from './hooks';
import { generateUiSchema, transformJSONSchema } from './utils';

interface ISingerSourceConfigProps {
  sourceDefinition: ISourceDefinition;
  onSettingsChange: (data: Record<string, string>, spec: JSONSchema, isValid: boolean) => void;
  initialSettings?: Record<string, unknown>;
  configSchema?: JSONSchema;
  secretConfig?: SecretConfig;
  disabled?: boolean;
}

const SingerSourceConfig: React.ForwardRefExoticComponent<
  React.PropsWithoutRef<ISingerSourceConfigProps> & React.RefAttributes<unknown>
> = React.forwardRef((props: ISingerSourceConfigProps, ref) => {
  const image = props.sourceDefinition?.options?.image;
  const { connectionSpecification, authSpec, loading } = useConfigSchema(image!, {
    connectionSpecification: props.configSchema,
  });
  if (!connectionSpecification && !loading) {
    return null;
  }
  let schema = {} as JSONSchema;
  let uiSchema = {};
  if (!loading && connectionSpecification) {
    schema = transformJSONSchema(connectionSpecification, authSpec);
    uiSchema = generateUiSchema(schema, props.sourceDefinition, authSpec);
  }
  return (
    <Container className={`p-t-lg p-b-lg configure-data__container ${classes.resourcesContainer}`}>
      {loading ? (
        <Loading size={64} />
      ) : (
        <JSONSchemaForm
          secretConfig={props.secretConfig}
          disabled={props.disabled}
          formData={props.initialSettings || {}}
          schema={schema}
          uiSchema={uiSchema}
          onChange={(config, isValid) => {
            props.onSettingsChange(config, connectionSpecification || {}, isValid);
          }}
          ref={ref}
        />
      )}
    </Container>
  );
});

export default SingerSourceConfig;
